var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "orderDetailTitle" }, [
      _c("p", { staticStyle: { "font-weight": "bold" } }, [_vm._v("订单详情")]),
      _vm.isShowTopBtn
        ? _c(
            "div",
            { staticClass: "orderDetailTitleButton" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.goAxisTravel },
                },
                [_vm._v("前往订单行程轴")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("updateCurrent", "my")
                    },
                  },
                },
                [_vm._v("返回主订单列表")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "orderDetailMain" },
      [
        _c("p", { staticClass: "p1" }, [_vm._v("订单状态")]),
        _c("orderStatus", { attrs: { tableData: _vm.tableData } }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "orderDetailMain" },
      [
        _c("p", { staticClass: "p1" }, [_vm._v("基本信息")]),
        _c("basicInformation", { attrs: { tableData: _vm.tableData } }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "orderDetailMain" },
      [
        _c("div", { staticClass: "orderDetailMainTitle" }, [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-right": "0.1rem",
                    "font-weight": "bold",
                  },
                },
                [_vm._v("发票信息")]
              ),
              _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
                _vm._v("修 改"),
              ]),
              _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
                _vm._v("保 存"),
              ]),
            ],
            1
          ),
        ]),
        _vm.tableData.length > 0
          ? _c("invoiceInformation", {
              attrs: { invoicingId: _vm.invoicingId },
              on: {
                userAddressId: function ($event) {
                  _vm.addressId = $event
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "orderDetailMain" },
      [
        _c("div", { staticClass: "orderDetailMainTitle" }, [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-right": "0.1rem",
                    "font-weight": "bold",
                  },
                },
                [_vm._v("收货人信息(旅游产品未预定确认信息接收人)")]
              ),
              _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
                _vm._v("修 改"),
              ]),
              _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
                _vm._v("保 存"),
              ]),
            ],
            1
          ),
        ]),
        _c("consigneeInformationVue", { attrs: { addressId: _vm.addressId } }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "orderDetailMain" },
      [
        _c("p", { staticClass: "p1" }, [_vm._v("供应商信息")]),
        _c("supplierInformationVue", {
          attrs: { orderId: _vm.datas.orderMainId },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "orderDetailMain" },
      [
        _c("div", { staticClass: "orderDetailMainTitle" }, [
          _c("p", { staticClass: "p1" }, [_vm._v("订单信息")]),
          _vm.tableData.length > 0
            ? _c("div", [
                _vm._v(" 订单金额: "),
                _c("span", { staticClass: "span1" }, [
                  _vm._v(_vm._s(_vm.tableData[0].orderPrice) + "元"),
                ]),
                _vm._v(
                  " 订单总配送费: +0.00元 订单优惠金额: " +
                    _vm._s(
                      _vm.tableData[0].integralPrice +
                        _vm.tableData[0].couponPrice
                    ) +
                    "元 已付款: "
                ),
                _c("span", { staticClass: "span1" }, [
                  _vm._v(" " + _vm._s(_vm.tableData[0].payPrice) + "元"),
                ]),
              ])
            : _vm._e(),
        ]),
        _c("staticTableVue", {
          attrs: { loading: _vm.loading, tableData: _vm.listDatas },
        }),
        _c("Pagination", {
          attrs: {
            currentPage: _vm.init.page,
            pageSizes: _vm.pageSizes,
            parentPageSize: 10,
            totalNumber: _vm.AllpagesNum,
          },
          on: { loadTable: _vm.loadTable },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }